export type SellVisibilityField = 'PRICE' | 'SPECIALPRICE' | 'DEPOSIT' | 'MONTHLYRATE' | 'FINALRATE'

// offers-explorer manda un oggetto con i soli toggle accesi del backoffice,
// es. { IS_VISIBLE_ON_WEBSITE_PRICE: true }: chiave assente = toggle spento.
// Senza configurazione (null) si mostra tutto, come prima.
export function isSellFieldVisible(
  fieldsVisibility: OfferGlobal.SellFieldsVisibility | null | undefined,
  field: SellVisibilityField,
): boolean {
  if (!fieldsVisibility) return true
  return Boolean(fieldsVisibility[`IS_VISIBLE_ON_WEBSITE_${field}`])
}
